/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const columnHeaderStyle = {
  justifyContent: "center",
  display: "flex",
  color: "#ffffff",
  fontSize: "50px",
  fontWeight: "700",
};

export const headerContainerStyle = {
  backgroundColor: "rgba(5, 5, 5, 1)",
  padding: "20px",
};
